"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var j=require("react"),i=require("styled-components"),T=require("@vfuk/core-number-badge"),b=require("@vfuk/core-base-props"),p=require("@vfuk/core-mixins");function m(e){return e&&e.__esModule?e:{default:e}}var c=m(j),f=m(i),k=m(T);function B(e,t,r){const a=e.getIconProperties(t);return r&&a.size[r]||a.size[a.defaultSize]}function q(e,t){const r=e.getIconProperties(t);if(r.widthOverride)return r.widthOverride}const I=p.createMixin((e,t,r,a)=>t?i.css`
      width: ${a||`${r.sm}px`};
      height: ${r.sm}px;

      ${p.respondTo.md(i.css`
        width: ${a||`${r.md}px`};
        height: ${r.md}px;
      `)}

      ${p.respondTo.lg(i.css`
        width: ${a||`${r.lg}px`};
        height: ${r.lg}px;
      `)}

    ${p.respondTo.xl(i.css`
        width: ${a||`${r.xl}px`};
        height: ${r.xl}px;
      `)}
    `:i.css`
        width: ${a||`${r.xl}px`};
        height: ${r.xl}px;
      `);var P=p.createMixin((e,t,r,a)=>{const o=B(e,a,t),l=q(e,a);return i.css`
    ${I(r,o,l)}
  `});const $=typeof f.default=="object"&&"default"in f.default?f.default.default:f.default,w=$.span(e=>{var t,r,a,o,l;const n=e.theme.getIconProperties(e.group),s=u=>n?.colorAppliesTo==="stroke"?`stroke: ${u};`:`>* { fill: ${u}; }`;return i.css`
    position: relative;
    display: inline-flex;
    vertical-align: middle;

    span {
      display: inline-flex;
    }

    svg {
      ${P(e.size,e.isResponsive,e.group)}

      ${s((r=(t=n?.appearance)==null?void 0:t[e.appearance])==null?void 0:r.color)}

      ${e.inverse&&s((o=(a=n?.appearance)==null?void 0:a[e.appearance])==null?void 0:o.inverse.color)}

      ${e.state&&s((l=n?.state)==null?void 0:l[e.state].color)}
    }
  `}),x=$.span(()=>i.css`
    display: inline-flex;
    vertical-align: text-bottom;
    width: 30px;
    height: 30px;
    background-color: ${"#ff00ff"};
  `),O=$.span(()=>i.css`
    position: absolute;
    right: -8px;
    top: -7px;
  `);var M=Object.freeze({__proto__:null,ErrorPinkBox:x,Icon:w,NumberBadgeContainer:O}),D=Object.defineProperty,C=Object.defineProperties,N=Object.getOwnPropertyDescriptors,y=Object.getOwnPropertySymbols,R=Object.prototype.hasOwnProperty,A=Object.prototype.propertyIsEnumerable,_=(e,t,r)=>t in e?D(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,F=(e,t)=>{for(var r in t||(t={}))R.call(t,r)&&_(e,r,t[r]);if(y)for(var r of y(t))A.call(t,r)&&_(e,r,t[r]);return e},G=(e,t)=>C(e,N(t));const S=({isResponsive:e=!0,appearance:t="primary",inverse:r=!1,group:a="system",state:o,size:l,numberBadge:n,name:s,dataAttributes:u,id:z,dataSelectorPrefix:h})=>{const E="Icon",v=i.useTheme();return(()=>{if(!v.doesIconGroupExist(a))return!0;const d=v.getIconProperties(a),g=new Set;return d.appearance&&g.add(!d.appearance[t]),d.state&&o&&g.add(!d.state[o]),g.has(!0)})()?c.default.createElement(x,null):c.default.createElement(w,G(F({id:z,state:o,"aria-hidden":"true",appearance:t,inverse:r,size:l,isResponsive:e,group:a},u),{"data-selector":b.getDataSelector(h),"data-component-name":E}),v.getIcon(s,a,c.default.createElement(x,null)),n&&a==="system"&&c.default.createElement(O,null,c.default.createElement(k.default,{number:n.number,appearance:r?n.appearance:"primary",dataSelectorPrefix:b.getDataSelector(h,"number-badge")})))};exports.Icon=S;exports.IconStyles=M;exports.default=S;exports.getIconSize=I;exports.iconSizes=P;
//# sourceMappingURL=index.cjs.map
